<template>
  <div v-if="!hideThis">
    <h3>Выберите способ получения займа</h3>
<!--    <div>-->
<!--      <label for="cdPaymentBase" class="instRadioInput">-->
<!--        <div class="fakeWrap" v-bind:class="{active: cdPayment === 'base'}">-->
<!--          <input type="radio" v-model="cdPayment" :value="'base'" id="cdPaymentBase">-->
<!--        </div>-->
<!--        <span>Прикрепить скан платежных реквизитов</span>-->
<!--      </label>-->
<!--      <label for="cdPaymentSbp" class="instRadioInput">-->
<!--        <div class="fakeWrap" v-bind:class="{active: cdPayment === 'sbp'}">-->
<!--          <input type="radio" v-model="cdPayment" :value="'sbp'" id="cdPaymentSbp">-->
<!--        </div>-->
<!--        <span>Выбрать банк СБП</span>-->
<!--      </label>-->
<!--    </div>-->
    <div class="instErrMsg" v-if="statusVuex.code !== 0">{{statusVuex.msg}}</div>
    <instSbp v-show="cdPayment === 'sbp'"></instSbp>
    <instFotoAdd :fieldName="'BankAccount'" v-show="cdPayment === 'base'"></instFotoAdd>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instSelectBankInfo",
  data(){
    return {
      hideThis:false
    }
  },
  components:{
    instFotoAdd:()=>import('@/components/inst/instFotoAdd.vue'),
    instSbp:()=>import('@/components/inst/instSbp.vue')
  },
  methods:{
    hideIfIsset(){
      if (this.demandState.allPhotosStatusList.BankAccount > 0) {
        this.hideThis = true;
        this.$store.dispatch('saveSendData', {
          target: 'BankAccount',
          value: this.demandState.allPhotosStatusList.BankAccount
        });
        this.$store.dispatch('saveSendData', {
          target: 'cdPayment',
          value: 'base'
        });
      }
    }
  },
  computed: {
    ...mapState({
      statusVuex:state => state.Form.workData.cdPayment,
      valueVuex: state => state.Form.sendData.cdPayment,
      demandState: state => state.instForm.demandState,
    }),
    fieldStatus() {
      return this.valueVuex;
    },
    cdPayment: {
      get() {
        return this.valueVuex;
      },
      set(value) {
        this.$store.dispatch('saveSendData', {
          target: 'cdPayment',
          value: value
        });
      }
    },
  },
  mounted() {
    this.hideIfIsset();
  }
}
</script>

<style scoped>
h3 {font-size: var(--font-size-20);margin: var(--font-size-24) auto;font-weight: 500}
</style>